var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCreated)?_c('created'):_c('not-created',{attrs:{"title":_vm.$t('Create wallet balancer', { account: _vm.accountShortName }),"account":_vm.accountShortName}})}
var staticRenderFns = []

export { render, staticRenderFns }